<div
    class="h-100 p-4 d-flex flex-column align-items-center justify-content-center"
>
    <wdx-icon
        class="mb-5"
        icon="right-from-bracket"
        size="4x"
        animation="beat"
    ></wdx-icon>
    <p class="fs-4 justify-self-center text-center mb-3">
        You will be logged out in
        <strong>{{ seconds }}</strong> seconds due to inactivity.
    </p>

    <button class="btn btn-primary mt-2" (click)="stayLoggedIn()">
        Stay Logged In
    </button>
</div>
